import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import SVGSprite from "@/components/Atoms/SVGSprite";
import IconButton from "@/components/Atoms/Button/IconButton";
import UserMention from "../UserMention";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const PostTitle = styled(Typography)`
  color: ${theme.colorsV2.gray.shade_800};
`;

export const PostMetadata = styled(FlexDiv)`
  align-items: center;
`;

export const UserInfo = styled(FlexDiv)`
  align-items: center;
  gap: 10px;
`;

export const UserData = styled(FlexDiv)`
  flex-direction: column;
  justify-content: center;
`;

export const Avatar = styled.img`
  height: 32px;
  width: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 1.5px solid ${theme.colorsV2.shyft.gold};
`;

export const UserAvatar = styled(FlexDiv)`
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #eee;
  margin-right: 6px;
  height: 34px;
  width: 34px;
`;

export const UserIcon = styled(SVGSprite)`
  height: 24px;
  width: 24px;
`;

export const Name = styled(Typography)`
  cursor: pointer;
  color: ${theme.colorsV2.gray.shade_700};
`;

export const FollowButton = styled(Typography)`
  color: ${theme.colorsV2.shyft.purple_text};
  cursor: pointer;
`;

export const UserType = styled(Typography)`
  color: ${({ isShyftUser }) =>
    isShyftUser
      ? theme.colorsV2.shyft.purple_text
      : theme.colorsV2.gray.shade_500};
  cursor: pointer;
`;

export const Duration = styled(Typography)`
  color: ${theme.colorsV2.gray.shade_500};
`;

export const PostContent = styled(UserMention)`
  color: ${theme.colorsV2.gray.shade_600};
`;

export const PostBanner = styled.img`
  border-radius: 12px;
  max-height: 220px;
  max-width: 100%;
  object-fit: contain;
`;

export const PostActions = styled(FlexDiv)`
  justify-content: space-between;
  align-items: center;
`;

export const ActionButton = styled(IconButton)`
  justify-content: space-between;
  align-items: center;
  padding: 0;
`;

export const ActionIcon = styled(SVGSprite)`
  height: 20px;
  width: 20px;
`;

export const VerificationBadge = styled(SVGSprite)`
  height: 16px;
  width: 16px;
`;
